
import FilesLink from './FilesLink'

export default function FolderItem({ item }) {

	return <FilesLink path={item.path} className='FolderLink'>
		📁 {item.name}
	</FilesLink>
}